import { render, staticRenderFns } from "./PendingApprovals.vue?vue&type=template&id=2c409cf4"
import script from "./PendingApprovals.vue?vue&type=script&lang=js"
export * from "./PendingApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports